var spacing = {
    spacing: function (factor) { return "".concat(0.5 * factor, "rem"); }
};
export default spacing;
